import React from "react";

export default function About() {
  return (
    <>
      {/* About Section */}
      <section id="about" className="section my-5">
        <div className="container">
          <h2 className="section-title h1 fw-bold mb-4" data-aos="fade-right">
            <i className="bi bi-info-circle me-2"></i>About Us
          </h2>
          <div className="row g-4">
            <div className="col-md-6 col-lg-4" data-aos="zoom-in">
              <div className="card-soft p-4 h-100">
                <div className="icon-bubble mb-3">
                  <i className="bi bi-lightbulb"></i>
                </div>
                <h5 className="fw-bold">Our Mission</h5>
                <p className="text-dark-50 mb-2">
                  Deliver innovative software and website solutions that empower
                  businesses to thrive.
                </p>
                <div className="small text-dark-50">
                  Innovation • Technology • Growth
                </div>
              </div>
            </div>

            <div
              className="col-md-6 col-lg-4"
              data-aos="zoom-in"
              data-aos-delay={60}
            >
              <div className="card-soft p-4 h-100">
                <div className="icon-bubble mb-3">
                  <i className="bi bi-check2-circle"></i>
                </div>
                <h5 className="fw-bold">Why Choose Us?</h5>
                <p className="text-dark-50 mb-2">
                  Tailored solutions, over 11 years of expertise, and a
                  customer-centric approach for unmatched satisfaction.
                </p>
                <div className="small text-dark-50">
                  Custom Software • Expertise • Support
                </div>
              </div>
            </div>

            <div
              className="col-md-6 col-lg-4"
              data-aos="zoom-in"
              data-aos-delay={120}
            >
              <div className="card-soft p-4 h-100">
                <div className="icon-bubble mb-3">
                  <i className="bi bi-gear"></i>
                </div>
                <h5 className="fw-bold">Our Services</h5>
                <p className="text-dark-50 mb-2">
                  Custom software, ERP platforms, POS systems, inventory
                  solutions, and more to drive business forward.
                </p>
                <div className="small text-dark-50">
                  ERP • POS • Web & Software Solutions
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section
        id="services"
        className="section"
        style={{ background: "#f56e0b78", padding: "60px 0" }}
      >
        <div className="container">
          <h2 className="section-title h1 fw-bold mb-4" data-aos="fade-right">
            <i className="bi bi-stars me-2"></i>What we do
          </h2>
          <div className="row g-4">
            <div className="col-md-6 col-lg-4" data-aos="zoom-in">
              <div className="card-soft p-4 h-100">
                <div className="icon-bubble mb-3">
                  <i className="bi bi-box-seam"></i>
                </div>
                <h5 className="fw-bold">Custom Software</h5>
                <p className="text-dark-50 mb-2">
                  Bespoke desktop & web apps with clean architecture, testing,
                  and CI/CD.
                </p>
                <div className="small text-dark-50">
                  .NET • C# • SQL Server • CQRS
                </div>
              </div>
            </div>

            <div
              className="col-md-6 col-lg-4"
              data-aos="zoom-in"
              data-aos-delay={60}
            >
              <div className="card-soft p-4 h-100">
                <div className="icon-bubble mb-3">
                  <i className="bi bi-globe2"></i>
                </div>
                <h5 className="fw-bold">Web & E‑commerce</h5>
                <p className="text-dark-50 mb-2">
                  Lightning‑fast websites and stores that convert and scale.
                </p>
                <div className="small text-dark-50">
                  Next.js • React • Tailwind • Payments
                </div>
              </div>
            </div>

            <div
              className="col-md-6 col-lg-4"
              data-aos="zoom-in"
              data-aos-delay={120}
            >
              <div className="card-soft p-4 h-100">
                <div className="icon-bubble mb-3">
                  <i className="bi bi-robot"></i>
                </div>
                <h5 className="fw-bold">AI Chatbots</h5>
                <p className="text-dark-50 mb-2">
                  Omnichannel assistants trained on your data, integrated with
                  CRM.
                </p>
                <div className="small text-dark-50">
                  RAG • Vector DB • Odoo CRM
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-4" data-aos="zoom-in">
              <div className="card-soft p-4 h-100">
                <div className="icon-bubble mb-3">
                  <i className="bi bi-layers"></i>
                </div>
                <h5 className="fw-bold">Odoo & ERP</h5>
                <p className="text-dark-50 mb-2">
                  CRM, inventory, and finance workflows tailored to your teams.
                </p>
                <div className="small text-dark-50">
                  Odoo • PostgreSQL • APIs
                </div>
              </div>
            </div>

            <div
              className="col-md-6 col-lg-4"
              data-aos="zoom-in"
              data-aos-delay={60}
            >
              <div className="card-soft p-4 h-100">
                <div className="icon-bubble mb-3">
                  <i className="bi bi-phone"></i>
                </div>
                <h5 className="fw-bold">Mobile Apps</h5>
                <p className="text-dark-50 mb-2">
                  Cross‑platform apps with native feel and real‑time sync.
                </p>
                <div className="small text-dark-50">Flutter • React Native</div>
              </div>
            </div>

            <div
              className="col-md-6 col-lg-4"
              data-aos="zoom-in"
              data-aos-delay={120}
            >
              <div className="card-soft p-4 h-100">
                <div className="icon-bubble mb-3">
                  <i className="bi bi-cloud"></i>
                </div>
                <h5 className="fw-bold">Cloud & DevOps</h5>
                <p className="text-dark-50 mb-2">
                  Secure, observable, and cost‑efficient infra.
                </p>
                <div className="small text-dark-50">
                  Azure • AWS • Docker • K8s
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Skills Section */}
      <section
        id="skills"
        className="section"
        style={{ background: "#f56e0b78", padding: "60px 0" }}
      >
        <div className="container">
          <div className="d-flex align-items-center justify-content-between mb-4 flex-wrap gap-2">
            <h2 className="section-title h1 fw-bold m-0" data-aos="fade-right">
              <i className="bi bi-tools me-2"></i>Professional Skills &
              Expertise
            </h2>
          </div>

          <p className="text-dark-50 mb-5" data-aos="fade-up">
            With over 11 years of experience in software and website
            development, I specialize in creating efficient and innovative
            solutions tailored to business needs.
          </p>

          <div className="row g-4">
            {/* Example Skill Card */}
            {[
              {
                title: "C# & .NET Development",
                icon: "bi-code-slash",
                value: 95,
              },
              {
                title: "Database Management (MSSQL, MySQL)",
                icon: "bi-database-fill",
                value: 90,
              },
              { title: "API Integration", icon: "bi-plug", value: 90 },
              {
                title: "Desktop Software Development",
                icon: "bi-laptop",
                value: 85,
              },
              {
                title: "Web Development (PHP, WordPress, Blazor)",
                icon: "bi-window-stack",
                value: 85,
              },
              {
                title: "Reporting Tools (RDLC, Crystal Reports, FastReport)",
                icon: "bi-file-earmark-text",
                value: 80,
              },
              { title: "UI/UX Design", icon: "bi-palette", value: 70 },
            ].map((skill, index) => (
              <div
                key={index}
                className="col-md-6 col-lg-4"
                data-aos="fade-up"
                data-aos-delay={index * 60}
              >
                <div className="work-card card-soft h-100 p-4 text-center">
                  <div className="skill-title mb-2">
                    <i className={`bi ${skill.icon} me-2`}></i>
                    {skill.title}
                  </div>
                  <div className="progress mb-2" style={{ height: "8px" }}>
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{ width: `${skill.value}%` }}
                      aria-valuenow={skill.value}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    ></div>
                  </div>
                  <div className="skill-percent text-dark-50">
                    {skill.value}%
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
